export class ProductDto {
    Family: string;
    ProductCode: string;
    ReleaseNr: string;
    Date: string;
    Description: string;
    Signature: string;
    Active: boolean;
    WebServiceURL: string;
    WebServiceUrlNotReliable: boolean;
    ActivationMode: number;

    constructor(
        family: string,
        productCode: string = '',
        releaseNr: string = '',
        date: string = '',
        description: string = '',
        signature: string = ''
    ) {
        this.Family = family;
        this.ProductCode = productCode;
        this.ReleaseNr = releaseNr;
        this.Date = date;
        this.Description = description;
        this.Signature = signature;
        this.Active = false;
        this.WebServiceURL = '';
        this.WebServiceUrlNotReliable = false;
        this.ActivationMode = 0;
    }
}

export class VerticalProduct extends ProductDto {
    Signature: string;
}
